/* eslint-disable camelcase */
import { Button, ErrorMessage, CustomHeader, Screen, Text, TextInput } from "components"
import React, { useEffect, useRef, useState } from "react"
import { Image, Platform, TouchableOpacity, View } from "react-native"
import { style } from "./styles"
import { useNavigation } from "@react-navigation/native"
import { Controller, useForm } from "react-hook-form"
import { translate } from "i18n"

import moment from "moment"
import { DatePickerModal } from "react-native-paper-dates"
import DropDownPicker from "react-native-dropdown-picker"
import { colors } from "colors"
import { size } from "lodash"
import Icon from "@expo/vector-icons/MaterialCommunityIcons"
import { openCamera, uploadMedia } from "./helper/uploadImage"
import Modal from "react-native-modal"
import { ScrollView } from "react-native-gesture-handler"
import { useSessionExpired } from "utils/function"
import { useStores } from "models"
import flash from "config/flash"
import { observer } from "mobx-react-lite"
import { PhoneNumberInput } from "components/PhoneNumberInput"
import { ICountry } from "react-native-international-phone-number"

export const EditProfileScreen = observer(() => {
  const [isDatePickerVisible, setDatePickerVisibility] = useState(false)
  const navigation = useNavigation<any>()

  const [genderVisible, setGenderVisible] = useState(false)
  const [idVisible, setIDVisible] = useState(false)
  const [raceVisible, setRaceVisible] = useState(false)
  const [marriedVisible, setMarriedVisible] = useState(false)

  const [profilePicture, setProfilePicture] = useState("")
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false)
  const { sessionExpired } = useSessionExpired()
  const { userStore } = useStores()
  const { flagInfo, setFlagInfo } = userStore

  const [genderList] = useState([
    { label: translate("common.male").toUpperCase(), value: "male" },
    { label: translate("common.female").toUpperCase(), value: "female" },
  ])

  const [IDList] = useState([
    { label: translate("common.ic").toUpperCase(), value: "ic" },
    { label: translate("common.passport").toUpperCase(), value: "passport" },
  ])

  const [raceList] = useState([
    { label: translate("common.malay").toUpperCase(), value: "malay" },
    { label: translate("common.chinese").toUpperCase(), value: "chinese" },
    { label: translate("common.india").toUpperCase(), value: "indian" },
    { label: translate("common.others").toUpperCase(), value: "other" },
  ])

  const [maritalList] = useState([
    { label: translate("common.single").toUpperCase(), value: "single" },
    { label: translate("common.married").toUpperCase(), value: "married" },
  ])

  const fileInputRef = useRef(null)

  const { control, handleSubmit, setValue, clearErrors, watch } = useForm({
    reValidateMode: "onSubmit",
  })

  useEffect(() => {
    getMemberProfile()
  }, [])

  const showDatePicker = () => {
    setDatePickerVisibility(true)
  }

  const hideDatePicker = () => {
    setDatePickerVisibility(false)
  }

  const onCloseModal = () => {
    setIsModalVisible(false)
  }

  const getMemberProfile = async () => {
    await fetch(`${process.env.API_URL}/api/client/profile`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${userStore?.accessToken}`,
      },
    })
      .then(async (res) => {
        if (res?.ok) {
          const responseData = await res?.json()
          userStore?.update({ flagInfo: flagInfo })
          const {
            dob,
            email,
            name,
            gender,
            identity_number,
            identity_type,
            profile_picture,
            contact_number,
            race,
            marital_status,
          } = responseData?.data

          dob ? setValue("dob", dob) : null
          setValue("phoneNumber", contact_number)
          setValue("email", email)
          setValue("fullName", name)
          setValue("gender", gender)
          setValue("ic", identity_number)
          setValue("idType", identity_type === "1" ? "ic" : identity_type)
          setValue("race", race)
          setValue("maritalStatus", marital_status)
          setProfilePicture(profile_picture)
        } else {
          const errorMsg = await res?.json()
          if (errorMsg?.error === "Token expired" || errorMsg?.error === "Invalid token") {
            sessionExpired()
          } else {
            flash("error", translate("errors.failedToRetreiveMember"))
          }
        }
      })
      .catch((e) => {
        flash("error", translate("errors.failedToRetreiveMember"))
        console.error(e)
      })
  }

  const updateDetails = (e) => {
    const ic = e?.nativeEvent?.text
    if (size(ic) === 12) {
      const birthDatePart = ic.substr(0, 6)

      // Determine the birth year
      const currentYear = new Date().getFullYear()
      const currentCentury = Math.floor(currentYear / 100) // Determine the current century (e.g., 20 or 21)
      let birthYear = parseInt(birthDatePart.substr(0, 2), 10) // Extract the year part from the IC

      // Determine the full birth year based on the current century
      if (birthYear <= currentYear % 100) {
        birthYear += currentCentury * 100
      } else {
        birthYear += (currentCentury - 1) * 100
      }

      // const birthMonth = birthDatePart.substr(2, 2) - 1
      // const birthDay = birthDatePart.substr(4, 2)

      // Format the birthDate as DD-MM-YYYY
      // const formattedBirthDate = `${birthDay}-${birthMonth + 1}-${birthYear}`

      // setValue("dob", moment(formattedBirthDate, "DD-MM-YYYY").toDate())

      // Determine the gender
      const lastDigit = parseInt(ic.substr(-1), 10)
      const gender = lastDigit % 2 === 0 ? 2 : 1

      setValue("gender", gender)
    }
  }

  const flagOnChange = (data: any) => {
    setFlagInfo(data)
    console.log("THIS: ", flagInfo)
  }

  const onSubmit = async (data) => {
    await fetch(`${process.env.API_URL}/api/client/profile`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${userStore?.accessToken}`,
      },
      body: JSON.stringify({
        name: data?.fullName,
        identity_type: data?.idType,
        identity_number: data?.ic,
        dob: data?.dob,
        gender: data?.gender,
        email: data?.email,
        race: data?.race,
        marital_status: data?.maritalStatus,
      }),
    })
      .then(async (res) => {
        if (res?.ok) {
          userStore?.update({
            fullName: data?.fullName,
          })
          navigation.goBack()
          flash("success", translate("editProfileScreen.successUpdate"))
        } else {
          const errorMsg = await res?.json()
          if (errorMsg?.error === "Token expired" || errorMsg?.error === "Invalid token") {
            sessionExpired()
          } else {
            flash("error", translate("errors.failedToUpdateProfile"))
          }
        }
      })
      .catch((e) => {
        flash("error", translate("errors.failedToUpdateProfile"))
        console.error(e)
      })
  }

  const updateImage = async (result: any) => {
    const formData = new FormData()

    if (Platform.OS === "web") {
      formData.append("filename", result)
    } else {
      formData.append("filename", {
        uri: result.path,
        type: result.mime,
        name: "filename",
      })
    }

    try {
      const response = await fetch(`${process.env.API_URL}/api/client/uploadprofile`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${userStore?.accessToken}`,
          "Access-Control-Allow-Origin": "*",
        },
        body: formData,
      })

      if (response.ok) {
        const responseData = await response.json()
        setIsModalVisible(false)
        userStore?.update({ profileImage: responseData?.data })
        setProfilePicture(responseData?.data)
        flash("success", translate("common.uploadSuccess"))
      } else {
        const errorMsg = await response.json()
        if (errorMsg?.error === "Token expired" || errorMsg?.error === "Invalid token") {
          sessionExpired()
        } else {
          console.log(errorMsg)
          translate("errors.failedToUpload")
        }
      }
    } catch (error) {
      console.error(error)
      translate("errors.failedToUpload")
    }
  }

  const onPressUpload = async (type: "camera" | "file") => {
    if (Platform.OS === "web") {
      fileInputRef?.current?.click()
    } else if (type === "camera") {
      await openCamera((e) => {
        updateImage(e)
      })
    } else if (type === "file") {
      uploadMedia((e) => {
        updateImage(e)
      })
    }
  }

  return (
    <>
      <CustomHeader
        headerTitle={translate("editProfileScreen.title")}
        height={160}
        showBackButton
        withBalls
        longHeader
      />
      <Screen>
        <View style={style.bottomContainer}>
          <View style={style.overHeadContainer}>
            <TouchableOpacity
              activeOpacity={0.9}
              onPress={() => {
                Platform.OS === "web" ? onPressUpload("file") : setIsModalVisible(true)
              }}
              style={style.overHeadButton}
            >
              <>
                {profilePicture ? (
                  <Image
                    source={{ uri: profilePicture }}
                    style={style.profilePictureImage}
                    resizeMode="cover"
                  />
                ) : (
                  <>
                    <Icon name="camera-outline" size={48} color={colors.lightGrey} />
                  </>
                )}
              </>
              {Platform.OS === "web" && (
                <input
                  accept="image/*"
                  ref={fileInputRef}
                  type="file"
                  // eslint-disable-next-line react-native/no-inline-styles
                  style={{ display: "none" }}
                  onChange={(e) =>
                    uploadMedia(e, (image) => {
                      updateImage(image)
                      setProfilePicture(image)
                    })
                  }
                />
              )}
            </TouchableOpacity>
          </View>
          <ScrollView
            bounces={false}
            style={style.scrollView}
            contentContainerStyle={style.scrollViewContentContainer}
            showsVerticalScrollIndicator={false}
          >
            <View style={style.bottomContentContainer}>
              <Controller
                name="phoneNumber"
                control={control}
                rules={{
                  required: translate("errors.required"),
                }}
                render={({ field: { onChange, value: formattedPhoneNumberWithValueCode }, fieldState: { error } }) => {

                  const currentCallingCode = flagInfo?.callingCode?.startsWith('+')
                    ? flagInfo.callingCode.slice(1)
                    : flagInfo?.callingCode;

                  let userPhoneNumberOnly = formattedPhoneNumberWithValueCode || '';
                  if (currentCallingCode && formattedPhoneNumberWithValueCode?.startsWith(`+${currentCallingCode}`)) {
                    userPhoneNumberOnly = formattedPhoneNumberWithValueCode.slice(`+${currentCallingCode}`.length);
                  } else if (currentCallingCode && formattedPhoneNumberWithValueCode?.startsWith(currentCallingCode)) {
                    userPhoneNumberOnly = formattedPhoneNumberWithValueCode.slice(currentCallingCode.length);
                  }

                  return (
                    <PhoneNumberInput
                      value={userPhoneNumberOnly || ""}
                      editable={false}
                      onChange={(formattedPhoneNumber) => {
                        onChange(formattedPhoneNumber);
                      }}
                      onCustomFocus={() => clearErrors('phoneNumber')}
                      fieldError={error}
                      errorMessage={error?.message}
                      placeholder={translate("loginScreen.phoneNumberPlaceholder")}
                      title={
                        <Text>
                          {translate("loginScreen.phoneNumber")}
                          <Text style={{ color: "red" }}>*</Text>
                        </Text>
                      }
                      containerStyle={style.inputContainer}
                      inputStyle={style.inputStyle}
                      onCountryChange={(country) => flagOnChange(country)}
                      defaultCountry={flagInfo.cca2}
                    />
                  )
                }}
              />

              <View style={style.idContainer}>
                <Controller
                  name="idType"
                  control={control}
                  rules={
                    {
                      // required: translate("errors.required"),
                    }
                  }
                  defaultValue={"ic"}
                  render={({ field: { onChange, value }, fieldState: { error } }) => {
                    return (
                      <>
                        <View style={style.idTypeContainer}>
                          <View style={style.titleContainer}>
                            <Text style={style.title}>{translate("registerScreen.idType")}</Text>
                          </View>
                          <DropDownPicker
                            style={[style.dropdown, error && style.errorTextField]}
                            dropDownContainerStyle={{
                              borderColor: colors.inputFieldBorder,
                              backgroundColor: "white",
                            }}
                            open={idVisible}
                            listMode="SCROLLVIEW"
                            dropDownDirection="BOTTOM"
                            value={value}
                            items={IDList}
                            setOpen={() => {
                              setIDVisible(!idVisible)
                              setGenderVisible(false)
                            }}
                            onSelectItem={(e) => onChange(e?.value)}
                          />
                          {error && (
                            <ErrorMessage errorType={error.type} customMessage={error?.message} />
                          )}
                        </View>
                      </>
                    )
                  }}
                />
                <Controller
                  name="ic"
                  control={control}
                  // rules={{
                  //   required: translate("errors.required"),
                  // }}
                  render={({ field: { onChange, value }, fieldState: { error } }) => {
                    return (
                      <View style={style.idNoContainer}>
                        <TextInput
                          onFocus={() => clearErrors("ic")}
                          keyboardType="numeric"
                          value={value}
                          onChangeText={onChange}
                          onEndEditing={updateDetails}
                          onSubmitEditing={updateDetails}
                          error={error}
                          title={translate("registerScreen.ic")}
                          errorMessage={error?.message}
                          placeholder={translate("registerScreen.icPlaceholder")}
                          containerStyle={style.inputContainer}
                          style={style.inputStyle}
                        />
                      </View>
                    )
                  }}
                />
              </View>
              <Controller
                name="fullName"
                control={control}
                rules={{
                  required: translate("errors.required"),
                }}
                render={({ field: { onChange, value }, fieldState: { error } }) => {
                  return (
                    <View>
                      <TextInput
                        onFocus={() => clearErrors("fullName")}
                        value={value}
                        onChangeText={onChange}
                        error={error}
                        title={
                          <Text>
                            {translate("registerScreen.fullName")}
                            <Text style={{ color: "red" }}>*</Text>
                          </Text>
                        }
                        errorMessage={error?.message}
                        placeholder={translate("registerScreen.fullNamePlaceholder")}
                        containerStyle={style.inputContainer}
                        style={style.inputStyle}
                      />
                    </View>
                  )
                }}
              />
              <Controller
                name="dob"
                control={control}
                rules={{
                  required: translate("errors.required"),
                }}
                render={({ field: { value }, fieldState: { error } }) => {
                  return (
                    <>
                      <TextInput
                        error={error}
                        errorMessage={error?.message}
                        value={value && moment(value).format("DD-MM-YYYY")}
                        onPress={!watch("dob") ? showDatePicker : null}
                        title={
                          <Text>
                            DOB<Text style={{ color: "red" }}>*</Text>
                          </Text>
                        }
                        editable={watch("dob") === ""}
                        selectTextOnFocus={false}
                        placeholder={translate("editProfileScreen.dobPlaceholder")}
                        textFieldContainer={error && style.errorTextField}
                      />
                      <DatePickerModal
                        closeIcon={() => null}
                        locale={"en"}
                        date={value}
                        mode="single"
                        visible={isDatePickerVisible}
                        onDismiss={hideDatePicker}
                        onConfirm={(e) => {
                          setValue("dob", e?.date)
                          hideDatePicker()
                        }}
                        endYear={new Date().getFullYear()}
                        inputEnabled={false}
                        saveLabel={translate("common.save")}
                        uppercase
                        label=" "
                        validRange={{ endDate: new Date() }}
                      />
                    </>
                  )
                }}
              />

              <Controller
                name="email"
                control={control}
                rules={{
                  // required: translate("errors.required"),
                  pattern: {
                    value:
                      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                    message: translate("errors.invalidEmail"),
                  },
                }}
                render={({ field: { onChange, value }, fieldState: { error } }) => {
                  return (
                    <>
                      <TextInput
                        onFocus={() => clearErrors("email")}
                        error={error}
                        errorMessage={error?.message}
                        title={translate("editProfileScreen.email")}
                        value={value}
                        onChangeText={onChange}
                        autoCapitalize="none"
                        autoComplete="email"
                        autoCorrect={false}
                        placeholder={translate("editProfileScreen.emailPlaceholder")}
                      />
                    </>
                  )
                }}
              />

              <View style={[style.idContainer, { zIndex: 10000 }]}>
                <Controller
                  name="gender"
                  control={control}
                  rules={{
                    required: translate("errors.required"),
                  }}
                  defaultValue={"male"}
                  render={({ field: { onChange, value }, fieldState: { error } }) => {
                    return (
                      <View style={{ position: "relative", zIndex: 10000, flex: 1 }}>
                        <View style={style.titleContainer}>
                          <Text style={style.title}>
                            {translate("editProfileScreen.gender")}{" "}
                            <Text style={{ color: "red" }}>*</Text>
                          </Text>
                        </View>
                        <DropDownPicker
                          style={[style.dropdown, error && style.errorTextField]}
                          dropDownContainerStyle={{
                            borderColor: colors.inputFieldBorder,
                            backgroundColor: "white",
                            position: "absolute",
                            zIndex: 10000,
                          }}
                          placeholderStyle={{
                            color: colors.placeholder,
                          }}
                          placeholder={translate("editProfileScreen.genderPlaceholder")}
                          open={genderVisible}
                          listMode="SCROLLVIEW"
                          dropDownDirection="BOTTOM"
                          value={value}
                          items={genderList}
                          setOpen={() => {
                            setGenderVisible(!genderVisible)
                          }}
                          onSelectItem={(e) => onChange(e?.value)}
                        />
                        {error && (
                          <ErrorMessage errorType={error.type} customMessage={error?.message} />
                        )}
                      </View>
                    )
                  }}
                />
              </View>

              <View style={[style.idContainer, { zIndex: 999 }]}>
                <Controller
                  name="race"
                  control={control}
                  rules={{
                    required: translate("errors.required"),
                  }}
                  defaultValue={"malay"}
                  render={({ field: { onChange, value }, fieldState: { error } }) => {
                    return (
                      <View style={{ position: "relative", zIndex: 10000, flex: 1 }}>
                        <View style={style.idTypeContainer}>
                          <View style={style.titleContainer}>
                            <Text>
                              {translate("registerScreen.race")}
                              <Text style={{ color: "red" }}>*</Text>
                            </Text>
                          </View>
                          <DropDownPicker
                            style={[style.dropdown, error && style.errorTextField]}
                            dropDownContainerStyle={{
                              borderColor: colors.inputFieldBorder,
                              backgroundColor: "white",
                              position: "absolute",
                              zIndex: 10000,
                            }}
                            placeholderStyle={{
                              color: colors.placeholder,
                            }}
                            open={raceVisible}
                            listMode="SCROLLVIEW"
                            dropDownDirection="BOTTOM"
                            value={value}
                            items={raceList}
                            setOpen={() => {
                              setRaceVisible(!raceVisible)
                            }}
                            // setValue={onChange}
                            onSelectItem={(e) => onChange(e?.value)}
                          />
                          {error && (
                            <ErrorMessage errorType={error.type} customMessage={error?.message} />
                          )}
                        </View>
                      </View>
                    )
                  }}
                />
              </View>

              <View style={[style.idContainer, { zIndex: 777 }]}>
                <Controller
                  name="maritalStatus"
                  control={control}
                  rules={{
                    required: translate("errors.required"),
                  }}
                  defaultValue={"single"}
                  render={({ field: { onChange, value }, fieldState: { error } }) => {
                    return (
                      <View style={{ position: "relative", zIndex: 10000, flex: 1 }}>
                        <View style={style.idTypeContainer}>
                          <View style={style.titleContainer}>
                            <Text>
                              {translate("registerScreen.maritalStatus")}
                              <Text style={{ color: "red" }}>*</Text>
                            </Text>
                          </View>
                          <DropDownPicker
                            style={[style.dropdown, error && style.errorTextField]}
                            dropDownContainerStyle={{
                              borderColor: colors.inputFieldBorder,
                              backgroundColor: "white",
                              position: "absolute",
                              zIndex: 10000,
                            }}
                            placeholderStyle={{
                              color: colors.placeholder,
                            }}
                            open={marriedVisible}
                            listMode="SCROLLVIEW"
                            dropDownDirection="BOTTOM"
                            value={value}
                            items={maritalList}
                            setOpen={() => {
                              setMarriedVisible(!marriedVisible)
                            }}
                            // setValue={onChange}
                            onSelectItem={(e) => {
                              console.log("User selected value:", e?.value)
                              onChange(e?.value)
                            }}
                          />
                          {error && (
                            <ErrorMessage errorType={error.type} customMessage={error?.message} />
                          )}
                        </View>
                      </View>
                    )
                  }}
                />
              </View>
            </View>
          </ScrollView>
        </View>
      </Screen>
      <View style={style.stickyBottomContainer}>
        <Button
          onPress={handleSubmit(onSubmit)}
          title={translate("common.save")}
          style={style.buttonContainer}
          titleStyle={style.buttonText}
        />
      </View>

      <Modal
        isVisible={isModalVisible}
        style={style.modalContainer}
        onBackdropPress={() => onCloseModal()}
        onBackButtonPress={() => onCloseModal()}
      >
        <View style={style.modalContentContainer}>
          <TouchableOpacity
            style={style.modalContentButton}
            onPress={() => {
              onPressUpload("camera")
            }}
          >
            <Text>{translate("editProfileScreen.takePhoto")}</Text>
          </TouchableOpacity>
          <TouchableOpacity
            style={style.modalContentButton}
            onPress={() => {
              onPressUpload("file")
            }}
          >
            <Text>{translate("editProfileScreen.uploadGallery")}</Text>
          </TouchableOpacity>
        </View>
      </Modal>
    </>
  )
})
